import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormatFileEnum } from '@fleet-beat/editor';

@Component({
  selector: 'fb-format-file-icon',
  templateUrl: './format-file-icon.component.html',
  styleUrls: ['./format-file-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormatFileIconComponent {
  @Input() format: FormatFileEnum;
}
